<template>
  <kst-form v-if="salesId" no-bezel class="block">
    <template #top-right>
      <kst-button action-mode full-label
        class="is-primary"
        :has-access="access.Act_New"
        :module="Model.Module"
        :moduleType="Model.ModuleType.New"
        :urlParams="urlParams"
      />
    </template>
  </kst-form>
</template>

<script>
import Catalog from "../InvCatalog.js";
import Model from "../InvModel.js";

export default {
  props: {
    access: Object,
    salesId: Number
  },
  data: () => ({
    Model: Model
  }),
  computed: {
    urlParams() {
      return this.$kst.Route.getParams({
        [Catalog.SalesDraftID.Param]: this.salesId
      });
    }
  }
}
</script>